import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Labels from '../../components/translations/translation.json'
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import './policyModal.css';
import ButtonMailto from '../../components/email/buttonEmail';

function PolicyModal(props) {
  const [open] = useState(true);
  const [close] = useState(true);
  const [scroll, setScroll] = React.useState('paper');

  const handleClickOpen = (scrollType) => () => {
    // setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    props.callbackClose();
  }

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
      <DialogTitle id="scroll-dialog-title"  className="dialogTitle-policyModal">...
          {close ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#000',
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            className="dialogPara-policyModal"
          >
            {props.errorText ? <p className="first-para">{props.errorText}</p> : 
            <span>
            <p className="first-heading">{Labels[props.langCode].SNCB_PERSONAL_DATA}</p>

            <p className="first-para">{Labels[props.langCode].PARA_1}</p>

            <p className="second-para">{Labels[props.langCode].PARA_2}</p>

            <p className="first-heading">{Labels[props.langCode].PARA_3}</p>

            <p className="third-para">{Labels[props.langCode].PARA_4}</p>

            
          
            { props.langCode === "EN" ? 
            <p className='policyModal-paras'>{Labels[props.langCode].PARA_5}
            <a href="https://www.belgiantrain.be/en/privacy"  className='anchorTag-privacyPolicy' target="_blank">https://www.belgiantrain.be/en/privacy</a>.</p>
             : ""
            }
            { props.langCode === "NL" ? 
            <p className='policyModal-paras'>{Labels[props.langCode].PARA_5}
            <a href="https://www.belgiantrain.be/nl/privacy" className='anchorTag-privacyPolicy' target="_blank">https://www.belgiantrain.be/nl/privacy</a>.</p>
             : ""
            }

          

            <p className="third-heading">{Labels[props.langCode].PARA_6}</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_7}</p>

            <p className="first-heading">Cookies</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_8}.</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_9}</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_10}</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_11}  <a  className='anchorTag-privacyPolicy' href="https://www.allaboutcookies.org/" target="_blank">www.allaboutcookies.org</a>.</p>
             
            <p className='policyModal-paras'>{Labels[props.langCode].PARA_12} </p>

            <p className="fourth-heading">{Labels[props.langCode].PARA_13} </p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_14} </p>

            <p className="fourth-heading">{Labels[props.langCode].PARA_15} </p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_16}</p>

            <p className="first-heading">{Labels[props.langCode].PARA_17}</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_18}</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_19}</p>

            <p className="first-heading">{Labels[props.langCode].PARA_20}</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_21}</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_22}</p>

            <p className="fourth-heading">{Labels[props.langCode].PARA_23}</p>

            <p className='policyModal-paras'>{Labels[props.langCode].PARA_24}<ButtonMailto style={{fontSize: '16px',fontWeight : '400',fontFamily : 'Book'}}  label="privacy@b-rail.be" mailto="mailto:privacy@b-rail.be" />.</p>

            { props.langCode === "EN" ? 
            <p className='policyModal-paras'>{Labels[props.langCode].PARA_25} <a className='anchorTag-privacyPolicy'  href="https://www.belgiantrain.be/en/privacy"  target="_blank">https://www.belgiantrain.be/en/privacy</a>.</p> : ""
          }
          { props.langCode === "NL" ? 
          <p className='policyModal-paras'>{Labels[props.langCode].PARA_25} <a className='anchorTag-privacyPolicy' href="https://www.belgiantrain.be/nl/privacy"  target="_blank">https://www.belgiantrain.be/nl/privacy</a>.</p> : ""
        }
        { props.langCode === "FR" ? 
        <p className='policyModal-paras'>{Labels[props.langCode].PARA_25} <a className='anchorTag-privacyPolicy' href="https://www.belgiantrain.be/fr/privacy"  target="_blank">https://www.belgiantrain.be/fr/privacy</a>.</p> : ""
      }
      { props.langCode === "DE" ? 
      <p className='policyModal-paras'>{Labels[props.langCode].PARA_25} <a className='anchorTag-privacyPolicy' href="https://www.belgiantrain.be/de/privacy"  target="_blank">https://www.belgiantrain.be/de/privacy</a>.</p> : ""
    }
          </span> }
          </DialogContentText>
        </DialogContent>
        <DialogActions className="btn-wrapper" onClick={handleClose}>
          <Button className='btn-ok-privacyPolicy'>{Labels[props.langCode].CLOSE}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

PolicyModal.propTypes = {
  langCode: PropTypes.string,
  callbackClose: PropTypes.func,
  errorText: PropTypes.string,
};

export default PolicyModal;